import { render, staticRenderFns } from "./IndicadoresAnalises.vue?vue&type=template&id=209221e3&scoped=true&lang=pug&"
import script from "./IndicadoresAnalises.vue?vue&type=script&lang=js&"
export * from "./IndicadoresAnalises.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresAnalises.vue?vue&type=style&index=0&id=209221e3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209221e3",
  null
  
)

export default component.exports